<template>
    <v-card :loading="loading" :to="{name: route, params: params}" :disabled="disabled" rounded="xl" elevation="9" append>
        <v-img class="card-header-wrapper" :style="{backgroundColor: headlineColor}">
            <v-row class="card-header" align="center" justify="center">
                <img ref="imageDiv" v-if="imageURL !== undefined && imageURL !== null" class="bg-image" :class="{show: !loading}">
                <img v-if="svg !== undefined" class="svg-icon" :src="asset(svg)">
                <v-icon v-else class="mdi-icon" :color="iconColor">{{icon}}</v-icon>
            </v-row>
        </v-img>
        <v-card-text class="d-flex text justify-center align-center">{{ text }}</v-card-text>
    </v-card>
</template>

<style lang="scss" scoped>
.text{
    text-align: center; //ist für längere Texte zusätzlich notwendig
    height: 45%;
    font: normal normal normal 4vh/5vh 'RobotoMedium' !important;
    letter-spacing: 3px !important;
    color: $font-color !important;
}
.card-header-wrapper {
    height: 55%;
}
.card-header{
    margin: 0 !important;
    height: 100%;
}
.svg-icon{
    height: 90%;
}
.show{
    position: inherit !important;
    height: 100% !important;
    opacity: 1 !important;
}
.bg-image{
    position: absolute;
    height: 0;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    opacity: 0;
    transition: opacity .5s ease-in-out;
}
.mdi-icon{
    font-size: 12vh !important;
}

</style>
<script>
import axios from 'axios';
export default {
    props: {
        icon: String,
        svg: String,
        iconColor: String,
        headlineColor: String,
        text: {
            type: String,
            required: true
        },
        imageURL: String,
        route: {
            type: String,
            required: true
        },
        params: Object,
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: true,
        }
    },
    created() {
        if(this.imageURL !== null) {
            axios.get(this.imageURL, {
                responseType: 'arraybuffer',
            }).then((response) => {
                let mimetype = response.headers["Content-Type"];
                let base64File = Buffer.from(response.data, 'binary').toString('base64');
                let imageUrl = "url(data:"+mimetype+";base64,"+ base64File + ")";
                this.$refs.imageDiv.style.backgroundImage = imageUrl;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        } else {
            this.loading = false;
        }
    },
}
</script>
